import { render, staticRenderFns } from "./newConfiguration.vue?vue&type=template&id=343ec781"
import script from "./newConfiguration.vue?vue&type=script&lang=js"
export * from "./newConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports